var auth = require('@ycgame/auth').auth;
var authDialog = require('@ycgame/auth-components').authDialog;
var layer = require("./layer/layer");
$(function () {
    // 登录
    authDialog.showVendors();
    $(".lv1-content a").click(function (e) {
        if (!auth.member) {
            $.ycUserDialogOpen();
            e.stopImmediatePropagation();
        }else {
            var id = $(this).attr('data-id');
            skin(id)
        }
    });
    $(".lv2-content a").click(function (e) {
        if (!auth.member) {
            $.ycUserDialogOpen();
            e.stopImmediatePropagation();
        }else {
            var id = $(this).attr('data-id');
            hero(id)
        }
    });
    auth.bind(auth.EVENTS.LOGOUT, function () {
        location.reload();
        loginOut();
        sessionStorage.removeItem('markId');
    });

    auth.checkLogin();

    auth.bind(auth.EVENTS.LOGIN, function () {
        var markId = sessionStorage.getItem('markId');
        if (!markId){
            userData();
        }else {
            $(".login-username").html(markId);
        }
        $(".login").show();

    });

    var userDataUrl = 'https://act-api.bos.ycgame.com/game/characters';
    function userData() {
        open();
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $.each(data.data,function (index,value) {
                if (value.id == "ces3" && value.characters.length != 0){
                    $.each(value.characters,function (index,value) {
                        $(".username-user").append("<p data-id="+ value.dbid+ ">"+ value.name +"</p>");
                    })
                } else if (value.id == "ces3" && value.characters.length == 0) {
                    alert("您在游戏里尚未创建角色，请前往游戏里创建角色后再重试！");
                    $(".login-out").click();
                    return false;
                }
            });
            $(".username-user p").click(function () {
                $(".login-username").html($(this).html());
                var dbid = $(this).attr("data-id");
                electUser(dbid);
                sessionStorage.setItem('markId',$(this).html());
            })
        })
    }

    function electUser (id){
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/double-eleven/choose-character",
            data:{"dbid":id},
            xhrFields: {
                withCredentials: true
            }
        })
    }

    function loginOut (){
        $.ajax({
            type: "GET",
            url: "http://act-api.bos.ycgame.com/double-eleven/sessions/cancel",
            xhrFields: {
                withCredentials: true
            }
        })
    }



    function hero (id){
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/double-eleven/hero/" + id,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            alert("领取成功！")

        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "noChance") {
                alert("您的角色尚未达到领取资格！")
            }else if (xhr.responseJSON.code == "pass") {
                alert("您所选择的礼物超过您消费的额度，请重新选择小于或等于您消费额度的礼物！")
            }else if (xhr.responseJSON.code == "has") {
                alert("您已经领取过了！")
            }
        })
    }
    function skin (id){
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/double-eleven/skin/" + id,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            alert("领取成功！")
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "noChance") {
                alert("您的角色尚未达到领取资格！")
            }else if (xhr.responseJSON.code == "pass") {
                alert("您所选择的礼物超过您消费的额度，请重新选择小于或等于您消费额度的礼物！")
            }else if (xhr.responseJSON.code == "has") {
                alert("您已经领取过了！")
            }
        })
    }
//自定义滚动条
    $('.lv1-content').perfectScrollbar();
    $('.lv2-content').perfectScrollbar();


    // 角色选择
    var $user;
    $user = $('.username');
    $user.on('click', '.username-user p', function () {
        close();
    });
    function open(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $user, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });
        $user.data('layer', layerId);
        $user.find('.' + id).show().siblings().hide();

        cb && cb.call($user);
    }
    function close() {
        layer.close($user.data('layer'));
    }
});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 12
// module chunks = 1